<template>
  <div class="page-hp">
    <homepage-hero
      v-if="page.hero"
      :data="page.hero" />
    <blocks-loader :blocks="page.blocks" />
  </div>
</template>

<script setup>
  import transitions from '~/animations/pages'
  import { HOMEPAGE } from '~/graphql/pages/homepage'

  const { locale } = useI18n()
  const {
    previewToken, previewParam, previewTimestamp
  } = usePreview()
  const { data: page, error } = await useAsyncData(
    `homepage-${locale.value}`,
    () => useApi(HOMEPAGE, {}, {
      previewToken: previewToken.value,
      previewParam: previewParam.value
    }),
    {
      transform: r => r.entry,
      watch: [ previewTimestamp ]
    })

  /// Handle fetch errors
  if (error.value || !page.value) {
    console.error('Error fetching homepage data:', error.value)

    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found'
    })
  }

  useSeoData(page)

  useJsonld({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Veneta Cucine',
    'url': 'https://www.venetacucine.com',
    'logo': 'https://www.venetacucine.com/logo.svg',
    'sameAs': [
      'https://www.facebook.com/venetacucine/',
      'https://www.instagram.com/venetacucine/',
      'https://twitter.com/venetacucinespa/',
      'https://www.pinterest.it/venetacucine/',
      'https://www.youtube.com/user/venetacucinechannel',
      'https://www.linkedin.com/company/veneta-cucine-spa'
    ],
    'contactPoint': {
      '@type': 'ContactPoint',
      'contactType': 'customer service',
      'availableLanguage': [
        'Italian',
        'English',
        'French',
        'Spanish'
      ]
    }
  })

  definePageMeta({
    pageTransition: {
      name: 'page-transition',
      mode: 'out-in',
      ...transitions
    }
  })
</script>

<style lang="scss" scoped>
  .search-container {
    margin-bottom: 20px;
    position: relative;
  }

  .search-input {
    width: 100%;
    max-width: 400px;
    padding: 12px 16px;
    font-size: 16px;
    border: 2px solid #ddd;
    border-radius: 8px;
    outline: none;
    transition: border-color 0.3s ease;

    &:focus {
      border-color: #007bff;
    }

    &::placeholder {
      color: #999;
    }
  }

  .loading {
    position: absolute;
    top: 100%;
    left: 0;
    color: #007bff;
    font-size: 14px;
    margin-top: 5px;
  }

  table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #000;

    th,
    td {
      border: 1px solid #000;
      padding: 10px;
    }
  }

  #map {
    height: 100%;
  }
</style>
